module.exports = __webpack_public_path__ + "img/Homepage-Alien.dc477f6c.svg";